import clsx from "clsx";
import { agoLabel, warmth } from "@/lib/people";

/** Four small bars showing how warm a relationship is. Amber when it's cooling. */
export default function Warmth({ lastTouch }: { lastTouch: string | null }) {
  const level = warmth(lastTouch);
  const cool = level <= 1;
  return (
    <span
      className="inline-flex gap-[3px] align-middle"
      title={`Last in touch ${agoLabel(lastTouch)}`}
      aria-label={`Warmth ${level} of 4, last in touch ${agoLabel(lastTouch)}`}
    >
      {[1, 2, 3, 4].map((i) => (
        <i
          key={i}
          className={clsx(
            "block w-3.5 h-1 rounded-full",
            i <= level ? (cool ? "bg-accent-amber" : "bg-accent-green") : "bg-fg/[0.1]",
          )}
        />
      ))}
    </span>
  );
}
